@if (isLoading()) { <div class="mat-spinner"><mat-spinner></mat-spinner></div> }
@else {
    <mat-sidenav-container class="nav-container">
        <!--#region Navigation menu -->
        @if (
            isLoggedIn ()
            && !onChangePasswordScreen
        ) {
            <mat-sidenav 
                #sidenav 
                [mode]="
                    navService.isNavFixed() 
                    && !navService.isMobile() ? 'side' : 'over'
                " 
                [opened]="navService.isNavOpen()" 
                (openedChange)="navService.toggleNavOpen($event)"
                (mouseleave)="navService.toggleNavOpen(navService.isNavFixed())" 
                class="no-print"	
            >
                <pcg-mat-side-nav 
                    [user]="user"
                    (clickedSearchCv)="deactivateReports()"
                    id="sidenav"
                    class="no-print"
                ></pcg-mat-side-nav>
            </mat-sidenav>
        }
        <!--#endregion-->

        <!-- Rest of the site -->
        <mat-sidenav-content 
            class="m-print-0"
            [ngClass]="{'darker': navService.isNavOpen() }"
        >
            <!--#region Nav drawer -->
            @if (
                !navService.isMobile()
                && !navService.isNavFixed()
                && isLoggedIn()
                && !onChangePasswordScreen 			
            ) {
                <nav class="nav-drawer no-print">
                    <div class="nav-drawer-image">
                        <button 
                            class="d-flex align-items-center justify-content-center mt-2 fixed-toggle-btn"
                            (click)="navService.toggleNavFixed(true)" 
                        >
                            <fa-icon 
                                [icon]="faIconName.faArrowRight" 
                                class="fa-lg"
                            ></fa-icon>
                        </button>
                    </div>

                    @if (!isWitness()) {
                        <a 
                            class="drawer-icon pointer"
                            (click)="navService.homeButtonClick()"
                        >
                            <fa-icon
                                [icon]="faIconName.faHouse"
                                [class.active-drawer-item]="navService.selectedMainNav() === 'Home'"
                                title="Home"
                            ></fa-icon>
                        </a>
                    }

                    @if (!isApiUser) {
                        @for (nav of navService.navRoutes(); track nav;) {
                            @if (
                                navService.canViewNav(nav) 
                                && nav.icon
                                && nav.name != ""
                            ) {
                                <a 
                                    class="drawer-icon pointer" 
                                    [routerLink]="nav.href ?? nav.path"
                                >
                                    <fa-icon 
                                        [icon]="nav.icon" 
                                        [class.active-drawer-item]="
                                            nav.name === navService.selectedMainNav() 
                                            && navService.currentUrl() !== 'reports/control-value'
                                        "
                                        [title]="nav.tooltip ? nav.tooltip : ''"
                                    ></fa-icon>
                                </a>						
                            }
                        }

                        @if (
                            user?.controlValues 
                            && !isWitness()
                        ) {
                            <a 
                                class="drawer-icon pointer" 
                                (click)="takeToCvReport()"
                            >
                                <fa-icon 
                                    [icon]="faIconName.faBarcodeRead" 
                                    [class.active-drawer-item]='navService.currentUrl() === "reports/control-value"'
                                    title="Search Control Values"
                                ></fa-icon>
                            </a>
                        }
                    } @else {
                        <a 
                            class="drawer-icon pointer" 
                            (click)="takeToMyCompany()"
                        >
                            <fa-icon 
                                [icon]="faIconName.faGear" 
                                [class.active-drawer-item]='navService.currentUrl().startsWith("company/")'
                                title="Settings"
                            ></fa-icon>
                        </a>
                        <!-- getMainNavRoutes() gives API users only Admin > Developer. -->
                        @for (nav of navService.navRoutes(); track nav;) {
                            @if (
                                navService.canViewNav(nav)
                                && nav.icon
                                && nav.name != ""
                            ) {
                                <a
                                    class="drawer-icon pointer"
                                    [routerLink]="nav.href ?? nav.path"
                                >
                                    <fa-icon
                                        [icon]="nav.icon"
                                        [class.active-drawer-item]="nav.name === navService.selectedMainNav()"
                                        [title]="nav.tooltip ? nav.tooltip : ''"
                                    ></fa-icon>
                                </a>
                            }
                        }
                    }

                    <a 
                        class="drawer-icon pointer" 
                        (click)="takeToMyProfile()"
                    >
                        <fa-icon 
                            [icon]="faIconName.faUser" 
                            [class.active-drawer-item]='navService.selectedMainNav() === "profile"'
                            title="My Profile"
                        ></fa-icon>
                    </a>
                    @if (!isApiUser) {
                        <fa-icon 
                            [icon]="faIconName.faQuestionCircle" 
                            class="drawer-icon pointer"
                            (click)="openKnowledgeBase()"
                            title="Help"
                        ></fa-icon>
                    }
                    @if (
                        (
                            isSysAdmin 
                            || showSwapClient
                        )
                        && !isApiUser
                    ) {
                        <fa-icon 
                            class="drawer-icon fa-lg pointer" 
                            [icon]="faIconName.faSwap" 
                            (click)="openChangeClientModal();"
                            title="Change Agency"
                        ></fa-icon>	
                    }
                </nav>
            }
            <!--#endregion-->

            <!--#region Everything else -->
            <div 
                [ngClass]="
                    !isLoggedIn() 
                        ? '' 
                        : navService.isNavFixed() 
                            ? 'left-shift-fixed' 
                            : 'left-shift'
                "
            >
                <pcg-header
                    id="mainTopHeader"
                    (hamburgerClick)="navService.toggleNavOpen($event)"
                    [tabPanel]="tabPanel"
                    [onChangePasswordScreen]="onChangePasswordScreen"
                ></pcg-header>
                
                <div 
                    [ngClass]="
                        !isLoggedIn()
                            ? '' 
                            : (
                                gvs.showInstallNotification()
                                || (gvs.showScheduledInstallNotification() && gvs.isScheduledInstallNotificationMinimized())
                            ) 
                                ? navService.isNavFixed() 
                                    ? 'sse-notification-top-shift-fixed'
                                    : 'sse-notification-top-shift'
                                : navService.isNavFixed() 
                                    ? 'top-shift-fixed' 
                                    : 'top-shift'
                    "
                    [ngClass]="
                        !isLoggedIn()
                            ? '' 
                            : (gvs.showContactNotification())
                                ? navService.isNavFixed() 
                                    ? 'sse-notification-top-shift-fixed'
                                    : 'sse-notification-top-shift'
                                : navService.isNavFixed() 
                                    ? 'top-shift-fixed' 
                                    : 'top-shift'
                    "
                    class="mb-3"
                >
                    <main 
                        role="main" 
                        class="main-container"
                    >
                        <!-- S2N-3076: renders only for the View Only profile; see ViewOnlyBannerComponent -->
                        <s2-view-only-banner></s2-view-only-banner>
                        <mat-tab-nav-panel 
                            #tabPanel 
                            class="container"
                            [class]="navService?.selectedMainNav() === 'Home' ? 'mt-75px' : ''"
                        >
                            <router-outlet></router-outlet>
                        </mat-tab-nav-panel>
                    </main>
                    <s2-system-message></s2-system-message>
                    <s2-spinner></s2-spinner>
                </div>
            </div>
            <!--#endregion-->
            
            @if (!navService.isMobile()) {
                <div class="footer-ctnr no-print">
                    <div class="footer">
                        <span id="versionHistory">
                            @if (isLoggedIn()) {
                                <div 
                                
                                    class="blue-link" 
                                    (click)="toReleaseNotes()"
                                >Release Notes&nbsp;|&nbsp;</div>
                            }
                            <a 
                                href="https://www.schedule2.it/" 
                                rel="noreferrer noopener" 
                                target="_blank"
                                class="blue-link" 
                            >Schedule 2</a>
                            &nbsp;|&nbsp;
                            <a 
                                class="blue-link" 
                                href="/eula" 
                                class="blue-link" 
                                target="_blank"
                            >EULA</a>
                            &nbsp;|&nbsp;
                            <a 
                                class="blue-link" 
                                href="/privacy-policy" 
                                target="_blank"
                                class="blue-link" 
                            >Privacy Policy</a>
                            &nbsp;|&nbsp;
                            <a 
                                class="blue-link" 
                                href="/terms-conditions" 
                                target="_blank"
                                class="blue-link" 
                            >Terms and Conditions</a>
                            &nbsp;|&nbsp;
                            <a 
                                href="https://apps.apple.com/us/app/schedule2-it/id6462732846" 
                                rel="noreferrer noopener" 
                                target="_blank"
                                class="blue-link" 
                            >iOS App Store</a>
                            &nbsp;|&nbsp;
                            <a 
                                href="https://play.google.com/store/apps/details?id=schedule2it.app.twa&pcampaignid=web_share" 
                                rel="noreferrer noopener" 
                                target="_blank"
                                class="blue-link" 
                            >Google Play Store</a>
                            &nbsp;|&nbsp;
                            <a
                                href="https://schedule2.statuspage.io/"
                                rel="noreferrer noopener"
                                target="_blank"
                                class="blue-link"
                            >Status</a>
                        </span>
                    </div>
                </div>
            }

            @if (
                navService.isMobile()
                && isLoggedIn()
            ) {
                <div class="no-print mobile-footer">
                    <div
                        class="footer-icon p-1"
                        (click)="takeToHome()"
                    >
                        <div
                            class="footer-item"
                            [class.footer-item-active]="isOnHome"
                            [attr.aria-current]="isOnHome ? 'page' : null"
                        >
                            <fa-icon [icon]="faIconName.faHouse"></fa-icon>
                            <div class="itty-bitty-font">Home</div>
                            @if (isOnHome) { <div class="active-indicator"></div> }
                        </div>
                    </div>

                    @if (!isApiUser) {
                        <div
                            class="footer-icon p-1"
                            (click)="takeToInventory()"
                        >
                            <div
                                class="footer-item"
                                [class.footer-item-active]="isOnInventories"
                                [attr.aria-current]="isOnInventories ? 'page' : null"
                            >
                                <fa-icon [icon]="faIconName.faShelves"></fa-icon>
                                <div class="itty-bitty-font">Inventories</div>
                                @if (isOnInventories) { <div class="active-indicator"></div> }
                            </div>
                        </div>
                    }

                    <div
                        class="footer-icon p-1"
                        (click)="takeToMyProfile()"
                    >
                        <div
                            class="footer-item"
                            [class.footer-item-active]="isOnProfile"
                            [attr.aria-current]="isOnProfile ? 'page' : null"
                        >
                            <fa-icon [icon]="faIconName.faUser"></fa-icon>
                            <div class="itty-bitty-font">Profile</div>
                            @if (isOnProfile) { <div class="active-indicator"></div> }
                        </div>
                    </div>

                    @if (!isApiUser) {
                        <div
                            class="footer-icon p-1"
                            (click)="openKnowledgeBase()"
                        >
                            <div class="footer-item">
                                <fa-icon [icon]="faIconName.faQuestionCircle"></fa-icon>
                                <div class="itty-bitty-font">Help</div>
                            </div>
                        </div>
                    }
                </div>
            }
        </mat-sidenav-content>
    </mat-sidenav-container>
}

<ng-template 
    #modalChangeClient 
    let-modal
>
    <div class="modal-header">
		<h5 
            class="modal-title" 
            id="modal-basic-title"
        >Change Agency</h5>
		<button 
			type="button" 
			class="close" 
			aria-label="Close" 
			(click)="modal.dismiss()"
		><span aria-hidden="true">&times;</span></button>
	</div>

    <div class="modal-body">
        <!-- S2N-3242: this reads like the dropdown it replaces, but the list is inline rather
             than a floating p-select panel. An overlay panel never took a touch drag on iOS, so
             the list was unreachable on a phone; inline content scrolls there like anything
             else in the dialog. -->
        <button
            type="button"
            class="agency-switch-trigger"
            [class.open]="agencyListOpen()"
            [attr.aria-expanded]="agencyListOpen()"
            aria-haspopup="listbox"
            (click)="toggleAgencyList()"
        >
            <span class="agency-switch-trigger-text">{{ selectedAgencyText() }}</span>
            <span class="agency-switch-caret" aria-hidden="true"></span>
        </button>

        @if (agencyListOpen()) {
            <input
                #agencySearch
                type="text"
                class="form-control agency-switch-search"
                placeholder="Search agencies..."
                aria-label="Search agencies"
                autocomplete="off"
                [ngModel]="agencyFilter()"
                (ngModelChange)="agencyFilter.set($event)"
                [ngModelOptions]="{ standalone: true }"
            />

            <ul class="agency-switch-list" role="listbox">
                @for (agency of filteredClientItems(); track agency.value) {
                    <li role="presentation">
                        <button
                            type="button"
                            role="option"
                            class="agency-switch-option"
                            [class.selected]="agency.value === currentClientId"
                            [attr.aria-selected]="agency.value === currentClientId"
                            (click)="selectAgency(agency.value)"
                        >{{ agency.text }}</button>
                    </li>
                } @empty {
                    <li class="agency-switch-empty">No agencies match that search.</li>
                }
            </ul>
        }
    </div>

    <div class="modal-footer">
		<button 
            type="button" 
            class="btn btn-cancel btn-lg" 
            (click)="modal.dismiss()"
        >Cancel</button>
		<button 
            type="button" 
            class="btn btn-save btn-lg" 
            (click)="saveChangeClient(modal)"
        >Change Agency</button>
	</div>
</ng-template>